/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Addressbookapiclientsecret4Inputs */

const en_entity_addressbookapiclientsecret4 = /** @type {(inputs: Entity_Addressbookapiclientsecret4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Address Book API Client Secret`)
};

const de_entity_addressbookapiclientsecret4 = /** @type {(inputs: Entity_Addressbookapiclientsecret4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adressbuch API Client Secret`)
};

/**
* | output |
* | --- |
* | "Address Book API Client Secret" |
*
* @param {Entity_Addressbookapiclientsecret4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_addressbookapiclientsecret4 = /** @type {((inputs?: Entity_Addressbookapiclientsecret4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Addressbookapiclientsecret4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_addressbookapiclientsecret4(inputs)
	return de_entity_addressbookapiclientsecret4(inputs)
});
export { entity_addressbookapiclientsecret4 as "entity_addressBookApiClientSecret" }